import { tracking } from '@iwoca/frontend-tracking-library';
import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import CheckMarkBulletPoint from './CheckMarkBulletPoint';
import messages from './TopupEligibilitySection.messages';
import styles from './TopUpEligibilitySection.module.css';
import { REQUEST_CHANGE_ROUTER } from '../../../iwRouter/IwRouter.actions';
import ConfirmationButton from '../../ui/confirmationButton/ConfirmationButton';
import { getAllAccounts } from '../accountsSelector';

const mapStateToProps = (state: RootState) => {
    const endedLoan = _.find(getAllAccounts(state), {
        loan_status: 'ended'
    });

    return {
        accountId: endedLoan?.account_id
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    requestTopUp: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: { pathname: '/apply-flexi-loan/' }
        })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const TopUpEligibilitySection = ({
    requestTopUp,
    accountId
}: PropsFromRedux) => {
    const handleRequestTopUp = () => {
        tracking.ampli.newLoanRequestStarted({
            account_id: accountId
        });
        requestTopUp();
    };

    return (
        <div className={styles.HighlightSection}>
            <h2 className={styles.HighlightSectionTitle}>
                <FormattedMessage {...messages.goodNews} />
            </h2>
            <CheckMarkBulletPoint
                title={<FormattedMessage {...messages.bulletpointOneTitle} />}
                description={
                    <FormattedMessage {...messages.bulletpointOneDescription} />
                }
            />

            <CheckMarkBulletPoint
                title={<FormattedMessage {...messages.bulletpointTwoTitle} />}
                description={
                    <FormattedMessage {...messages.bulletpointTwoDescription} />
                }
            />

            <CheckMarkBulletPoint
                title={<FormattedMessage {...messages.bulletpointThreeTitle} />}
                description={
                    <FormattedMessage
                        {...messages.bulletpointThreeDescription}
                        values={{
                            dePhoneNumber: (
                                <a href="tel:+496994323020">069 / 94323020</a>
                            ),
                            bblLink: (
                                <a
                                    href="https://www.iwoca.co.uk/insights/coronavirus-bounce-back-loan/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    BBL
                                </a>
                            )
                        }}
                    />
                }
            />
            <ConfirmationButton
                className={styles.callToAction}
                onClick={handleRequestTopUp}
            >
                <FormattedMessage {...messages.applyNow} />
            </ConfirmationButton>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TopUpEligibilitySection);
